/**
 * The workspace's one agent identity. Replaces the old `GET /api/agents`
 * list: there is a single @yagni identity per workspace, held in workspace
 * settings rather than a table of agent rows.
 */
export interface WorkspaceAgentIdentity {
  id: string;
  name: string;
  displayName: string;
  avatarUrl: string | null;
  modelDefault: string | null;
  autonomousEnabled: boolean;
}

export async function fetchWorkspaceAgentIdentity(
  init?: RequestInit,
): Promise<WorkspaceAgentIdentity | null> {
  const res = await fetch("/api/settings/agent-identity", init);
  if (!res.ok) return null;
  return (await res.json()) as WorkspaceAgentIdentity;
}
